<common-card>
  <common-card-header>
    <div class="row no-gutters">
      <div class="col-auto mr-2">
        <nb-icon
          icon="clipboard-list"></nb-icon>
      </div>
      <div class="col">
        <h6>
          {{'modules.valet.valet_profile.withholdings.title' |translate}}
        </h6>
      </div>
    </div>
  </common-card-header>
  <common-card-body>
    <div class="row">
      <div class="col-auto">
        <button nbButton (click)="createWithholding()">
          {{'modules.valet.valet_profile.withholdings.add_withholding' | translate}}
        </button>
      </div>
      <div class="col-auto ml-auto text-right">
        {{'modules.valet.valet_profile.withholdings.available_remuneration_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableRemunerationAmount}"></ng-container><br>
        {{'modules.valet.valet_profile.withholdings.available_expense_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableExpenseAmount}"></ng-container><br><hr>
        {{'modules.valet.valet_profile.withholdings.available_total_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableTotalAmount}"></ng-container>
      </div>
    </div>
    <stbw-grid
      [filteringObject]="filteringObj"
      [settings]="settings"
      [source]="source"
      [isLoading]="loading"
      (edit)="updateWithholding($event)"
      (delete)="deleteWithholding($event)"
      (paginatorChangeEvent)="pageChanged($event)">
    </stbw-grid>
  </common-card-body>
</common-card>

<ng-template #amount let-amount="amount">
  <ng-container *ngIf="amount !== null"><strong>{{currencyFormatter.format(amount)}}</strong></ng-container>
  <ng-container *ngIf="amount === null">?</ng-container>
</ng-template>
